<template lang="pug" src="./dashboard-map.pug"></template>
<style lang="scss" src="./dashboard-map.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex';

import map from '@/components/map';
import detectMobileDevice from "@/utils/mobileDeviceCheck";

export default {
    components: {
        'v-map': map
    },
    data: () => ({
        settings: true,
        showDrivers: false,
        showGroupOrders: false,
        showNewOrders: true,
        isOrderGroupSwitchDisabled: false,
        orderId: null,
        startDateModal: false,
        endDateModal: false,
        filters: {
            startDate: new Date().addDays(-7).format('{yyyy}-{MM}-{dd}'),
            endDate: new Date().format('{yyyy}-{MM}-{dd}'),
            brandId: null
        }
    }),
    computed: {
        ...mapGetters(['roleName', 'user']),
        ...mapState({
            polyline: (state) => state.orders.polyline,
            brands: function(state) {
                return [{title: this.$vuetify.lang.t('$vuetify.pages.DashboardMap.allBrands'), id: null},...state.data.brands];
            }
        }),
        isShowGroupOrders() {
            const roles = ['boss', 'admin'];
            return roles.includes(this.roleName);
        },
        isMobileDevice() {
            return detectMobileDevice();
        }
    },
    created() {
        const { brandId } = this.user;

        if (brandId) {
            this.filters.brandId = brandId;
        }

        this.$store.dispatch('data/getBrands');
        this.$store.commit('orders/SET_POLYLINE', []);
        this.$store.commit('orders/CLEAR_ADDRESS_COORDS');
    },
    mounted() {
        this.$refs.map.startLoadDrivers();

        if (this.$route.params.id) {
            this.orderId = this.$route.params.id;

            this.showDriverPath();
        }
    },
    methods: {
        hideSettings() {
            this.settings = false;
        },

        showSettings() {
            this.settings = true;
        },

        showDriverPath() {
            this.$refs.map.showDriverPath(this.orderId);
        },

        changeShowDrivers() {
            if (!this.showDrivers) {
                return this.$refs.map.cancelLoadDrivers();
            }

            this.$refs.map.startLoadDrivers(true);
        },

        clearPolyline() {
            this.$store.commit('orders/SET_POLYLINE', []);
            this.$store.commit('orders/SET_ORDER_LINES', []);
            this.orderId = null;
        },

        changeOrderId() {
            if (this.polyline.length) {
                this.$store.commit('orders/SET_POLYLINE', this.polyline);
            }
        },

        changeStartDate() {
            this.$store.dispatch('orders/getGroupOrdersCoords', this.filters);
        },

        changeEndDate() {
            this.$store.dispatch('orders/getGroupOrdersCoords', this.filters);
        },

        changeBrand() {
            this.$store.dispatch('orders/getGroupOrdersCoords', this.filters);
        },

        async changeShowGroupOrders(val) {
            this.isOrderGroupSwitchDisabled = true;
            if (val) {
                await this.$store.dispatch('orders/getGroupOrdersCoords', this.filters);
            } else {
                this.$store.commit('orders/ClEAR_GROUP_ORDERS_COORDS');
            }
            this.isOrderGroupSwitchDisabled = false;
        }
    }
};
</script>
